<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>账户管理</BreadcrumbItem>
      <BreadcrumbItem>修改密码</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Card>
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          修改密码
        </p>
        <Form ref="formValidate" class="meeting-form" :model="user" :rules="ruleValidate" :label-width="150" >
          <FormItem label="用户名" prop="title">
            <div>{{ loginUser.name }}</div>
          </FormItem>
          <FormItem label="旧密码" prop="oldPwd">
            <Input size="large" v-model="user.oldPwd"></Input>
          </FormItem>
          <FormItem label="新密码" prop="newPwd">
            <Input size="large" v-model="user.newPwd" placeholder="8~20位字母和数字组合"></Input>
          </FormItem>
          <FormItem label="确认新密码" prop="confirmNewPwd">
            <Input size="large" v-model="user.confirmNewPwd" placeholder="再输入一次新密码"></Input>
          </FormItem>
          <p>
            <FormItem>
              <Button type="primary" style="float: right" size="large" long :disabled="saving" @click="save">确认</Button>
            </FormItem>
          </p>
        </Form>
      </Card>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import * as types from '../../store/mutation-types'

export default {
  name: 'ModifyPwd',
  data () {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请重复输入新密码'))
      } else if (value !== this.user.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    const validateNewPassCheck = (rule, value, callback) => {
      var patt = new RegExp('^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,20}$')
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value === this.user.oldPwd) {
        callback(new Error('新密码不能与旧密码一致'))
      } else if (!patt.test(value)) {
        callback(new Error('请输入8~20位字母和数字组合'))
      } else {
        callback()
      }
    }

    return {
      user: {},
      saving: false,

      ruleValidate: {
        oldPwd: [
          {required: true, message: '请输入旧密码', trigger: 'blur'}
        ],
        newPwd: [
          {required: true, validator: validateNewPassCheck, trigger: 'blur'}
        ],
        confirmNewPwd: [
          {required: true, validator: validatePassCheck, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    })
  },
  methods: {
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
      this.saved = false
    },
    save () {
      this.$refs['formValidate'].validate(async (valid) => {
        if (valid) {
          try {
            this.beforeSave()
            await this.$http.put('/api/admin/users/modifyPwd', this.user)
            this.afterSave()
            this.$Modal.success({
              title: '修改密码成功！',
              content: '请重新登录',
              okText: '确定',
              onOk: () => {
                this.$store.commit(types.SET_TOKEN, null)
                this.$router.push({
                  name: 'login'
                })
              }
            })
          } catch (e) {
            this.afterSave(e)
          }
        }
      })
    }
  }
}
</script>

<style scoped="scope" scss>
  .meeting-form {
    /*width: 1150px;*/
    margin: 0 auto;
    /*padding-right: 180px;*/
  }
  .ivu-form .ivu-form-item-label {
    font-size: 13px !important;
  }
  .demo-upload-list{
    display: inline-block;
    /*width: 60px;*/
    height: 60px;
    padding: 0 3px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/ModifyPwd.vue